const isMobileBrowser = () => {
  const userAgent = navigator.userAgent || navigator.vendor;
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Windows Phone|Opera Mini/i.test(userAgent);
};

const isMobileIOS = () => {
  const userAgent = navigator.userAgent || navigator.vendor;
  return /webOS|iPhone|iPad|iPod/i.test(userAgent);
};


const getDeviceType = () => {
  const ua = navigator.userAgent || navigator.vendor || ''

  if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) {
    return 'ios'
  }
  if (/Android/.test(ua)) {
    return 'android'
  }
  return 'desktop'
}

export { isMobileBrowser, isMobileIOS, getDeviceType }
